import React, { useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import DatePicker, { registerLocale } from "react-datepicker";
import iconcontentcalendar from "../../Images/Icons/iconcontentcalendar.png";
import * as dateHelper from "../../Helpers/DateHelper";
import { validationService } from "../../Services/validation.service";
import {
  posTag,
  numbersOnly,
  ictNumber,
  phoneNumber,
} from "../../Config/Regex";
import NumberFormat from "react-number-format";
import { convertToDecimalString } from "../../Helpers/DecimalNumberHelper";
import Tooltip from "../Common/Tooltip";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import hr from "date-fns/locale/hr";
import en from "date-fns/locale/en-US";
registerLocale("hr", hr);
registerLocale("en", en);

const PosData = (props) => {
  const goTo = (data) => {
    setCreatePosData({
      tag: data.tag,
      description: data.description,
      documentNumber: Number(data.documentNumber),
      posSerialNumber: data.posSerialNumber,
      subscriptionValidFrom: data.subscriptionValidFrom,
      //subscriptionValidTo: data.subscriptionValidTo,
      tid: data.tid,
      deposit: parseFloat(
        convertToDecimalString(document.getElementsByName("deposit")[0].value)
      ),
      inventoryNumber: data.inventoryNumber,
      msisdn: data.msisdn,
      //msisdn: data.msisdnCountry + data.msisdnPrefix + data.msisdn,
      workingMode: true,
    });
    props.nextStep();
  };

  const back = () => {
    props.prevStep();
  };

  const { selectedLanguageId } = useContext(GlobalContext);
  const { values, createPosData, setCreatePosData, handleInputChange } = props;
  const { register, handleSubmit, errors, control, setValue } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: { createPosData },
  });
  const { t: translator } = useTranslation();

  useEffect(() => {
    if (
      values.subscriptionValidFrom !== "" &&
      values.subscriptionValidTo !== ""
    ) {
      setValue("subscriptionValidFrom", new Date(values.subscriptionValidFrom));
      setValue("subscriptionValidTo", new Date(values.subscriptionValidTo));
    }
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Onboarding-POSData-DeviceInformation")}
            </legend>
            <div className="form-group">
              <label htmlFor="tid">TID</label>{" "}
              <Tooltip text={translator("PosDataTID-Msg")} />
              <input
                type="number"
                className="form-control"
                name="tid"
                ref={register({
                  required: false,
                  min: 12700000,
                  max: 12709999,
                  validate: function (value) {
                    if (value != "") {
                      return validationService.validateTid(
                        document.getElementsByName("tid")[0].value
                      );
                    }
                    return true;
                  },
                })}
                defaultValue={createPosData.tid}
              />
              {/* {errors.tid && errors.tid.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )} */}
              {errors.tid && errors.tid.type === "validate" && (
                <p className="text-danger">
                  {translator("ValidationMsg-Pos-Tid")}
                </p>
              )}
              {errors.tid &&
                (errors.tid.type === "min" || errors.tid.type === "max") && (
                  <p className="text-danger">
                    {translator("TIDLength-ValidationMsg")}
                  </p>
                )}
            </div>
            <div className="form-group">
              <label>{translator("ICT-number")}</label>{" "}
              <Tooltip text={translator("PosDataICTNum-Msg")} />
              <input
                type="text"
                className="form-control"
                name="inventoryNumber"
                ref={register({
                  required: true,
                  pattern: ictNumber,
                  maxLength: 25,
                  validate: () =>
                    validationService.validatePosInventoryNumber(
                      document.getElementsByName("inventoryNumber")[0].value
                    ),
                })}
                name="inventoryNumber"
                defaultValue={createPosData.inventoryNumber}
              />
              {errors.inventoryNumber &&
                errors.inventoryNumber.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              {errors.inventoryNumber &&
                errors.inventoryNumber.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-ICTAlreadyExist")}
                  </p>
                )}
              {errors.inventoryNumber &&
                errors.inventoryNumber.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-LettersAndNumbers")}
                  </p>
                )}
              {errors.inventoryNumber &&
                errors.inventoryNumber.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength25")}
                  </p>
                )}
            </div>
            <div className="form-group">
              <label htmlFor="posSerialNumber">
                {translator("POS-New_EditPOS-POSSerialNumber")}
              </label>{" "}
              <Tooltip text={translator("PosDataSerialNumber-Msg")} />
              <input
                type="text"
                className="form-control"
                name="posSerialNumber"
                ref={register({
                  required: true,
                  pattern: numbersOnly,
                  maxLength: 50,
                  validate: () =>
                    validationService.validatePosSerialNumber(
                      document.getElementsByName("posSerialNumber")[0].value
                    ),
                })}
                defaultValue={createPosData.posSerialNumber}
              />
              {errors.posSerialNumber &&
                errors.posSerialNumber.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              {errors.posSerialNumber &&
                errors.posSerialNumber.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-Pos-SerialNumber")}
                  </p>
                )}
              {errors.posSerialNumber &&
                errors.posSerialNumber.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-NumbersOnly")}
                  </p>
                )}
              {errors.posSerialNumber &&
                errors.posSerialNumber.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength50")}
                  </p>
                )}
            </div>
            <div className="form-group">
              <label>{translator("POSdevice-MSISDN")}</label>
              <input
                type="text"
                className="form-control"
                ref={register({
                  required: true,
                  maxLength: 50,
                  pattern: phoneNumber,
                })}
                name="msisdn"
                defaultValue={createPosData.msisdn}
              />
              {/* <div className="row">
                <div className="col-xs-12 col-sm-6 col-xl-3 pr-1 d-none d-sm-block">
                  <input
                    type="text"
                    className="form-control"
                    name="msisdnCountry"
                    defaultValue="+385"
                    disabled
                  />
                </div>
                <div className="col-xs-12 col-sm-6 col-xl-3 d-sm-none">
                  <input
                    type="text"
                    className="form-control"
                    name="msisdnCountry"
                    ref={register}
                    defaultValue="+385"
                    disabled
                  />
                </div>
                {window.innerWidth >= 1200 ? (
                  <div className="col-xs-12 col-sm-6 col-xl-4 pl-0 pr-0 d-none d-xl-block">
                    <select
                      name="msisdnPrefix"
                      ref={register({
                        validate: (value) => value !== "-1",
                      })}
                      className="form-control"
                      defaultValue={createPosData.msisdn.substr(4, 2)}
                    >
                      <option value="98">(0)98</option>
                      <option value="99">(0)99</option>
                    </select>
                  </div>
                ) : (
                  <div className="col-xs-12 col-sm-6 col-xl-4 d-sm-none mt-1">
                    <select
                      name="msisdnPrefix"
                      ref={register({
                        validate: (value) => value !== "-1",
                      })}
                      className="form-control"
                      defaultValue={createPosData.msisdn.substr(4, 2)}
                    >
                      <option value="98">(0)98</option>
                      <option value="99">(0)99</option>
                    </select>
                  </div>
                )}
                 <div className="col-xs-12 col-sm-6 col-xl-4 pl-0 d-none d-sm-block d-xl-none">
                  <select
                    name="msisdnPrefix"
                    ref={register({
                      validate: (value) => value !== "-1",
                    })}
                    className="form-control"
                  >
                    <option value="98">(0)98</option>
                    <option value="99">(0)99</option>
                  </select>
                </div>
                {window.innerWidth >= 1200 ? (
                  <div className="col-xs-12 col-xl-5 pl-1 d-none d-xl-block">
                    <input
                      type="number"
                      className="form-control"
                      ref={register({
                        required: true,
                        pattern: numbersOnly,
                        maxLength: 8,
                      })}
                      name="msisdn"
                      defaultValue={createPosData.msisdn.substring(6)}
                    />
                  </div>
                ) : (
                  <div className="col-xs-12 col-xl-5 mt-1 d-xl-none">
                    <input
                      type="number"
                      className="form-control"
                      ref={register({
                        required: true,
                        pattern: numbersOnly,
                        maxLength: 8,
                      })}
                      name="msisdn"
                      defaultValue={createPosData.msisdn}
                    />
                  </div>
                )}
              </div> */}
              {errors.msisdn && (
                <>
                  {errors.msisdn.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                  {errors.msisdn.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength50")}
                    </p>
                  )}
                  {errors.msisdn.type === "pattern" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-NumbersOnlyAndPlus")}
                    </p>
                  )}
                </>
              )}
            </div>
          </fieldset>
        </div>
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Onboarding-POSData-SubcriptionInformation")}
            </legend>
            <div className="form-group">
              <label>{translator("POS-New_EditPOS-Deposit")}</label>{" "}
              <Tooltip text={translator("PosDataDeposit-Msg")} />
              <Controller
                name="deposit"
                control={control}
                rules={{ maxLength: 9 }}
                as={
                  <NumberFormat
                    thousandSeparator={" "}
                    decimalSeparator={","}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    placeholder={"0,00"}
                    inputMode="numeric"
                    className="form-control"
                    allowNegative={false}
                  />
                }
                defaultValue={createPosData.deposit}
              />
              {errors.deposit && errors.deposit.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-Deposit")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="tag">
                {translator("Onboarding-POSData-DeviceTag")}{" "}
                <Tooltip text={translator("PosDataTag-Msg")} />
              </label>
              <input
                type="text"
                className="form-control"
                name="tag"
                ref={register({
                  //required: true,
                  pattern: posTag,
                  validate: () =>
                    validationService.validatePosTag(
                      document.getElementsByName("tag")[0].value
                    ),
                })}
                defaultValue={createPosData.tag}
              />
              {/* {errors.tag && errors.tag.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )} */}
              {errors.tag && errors.tag.type === "validate" && (
                <p className="text-danger">
                  {translator("ValidationMsg-Pos-Tag")}
                </p>
              )}
              {errors.tag && errors.tag.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-PosTag")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label> {translator("Onboarding-POSData-Description")}</label>{" "}
              <Tooltip text={translator("PosDataDescription-Msg")} />
              <textarea
                id="textArea"
                rows="4"
                className="form-control"
                name="description"
                ref={register({ maxLength: 250 })}
                defaultValue={createPosData.description}
              />
              {errors.description &&
                errors.description.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength250")}
                  </p>
                )}
            </div>
            <div className="form-group">
              <label>{translator("POS-New_EditPOS-DocumentNumber")}</label>{" "}
              <Tooltip text={translator("PosDataDocNum-Msg")} />
              <input
                type="number"
                className="form-control"
                ref={register({
                  required: true,
                  min: 1,
                  pattern: numbersOnly,
                  max: 999999,
                })}
                name="documentNumber"
                defaultValue={createPosData.documentNumber}
              />
              {errors.documentNumber &&
                errors.documentNumber.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              {errors.documentNumber &&
                errors.documentNumber.type === "max" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength6")}
                  </p>
                )}
              {errors.documentNumber &&
                errors.documentNumber.type === "min" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-Min1")}
                  </p>
                )}
              {errors.documentNumber &&
                errors.documentNumber.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-NumberOnly")}
                  </p>
                )}
            </div>
          </fieldset>
        </div>
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("POS-New_EditPOS-OtherData")}
            </legend>
            <div className="form-group">
              <label htmlFor="activationCode">
                {translator("Onboarding-POSData-SubcriptionFromDate")}
              </label>{" "}
              <Tooltip text={translator("PosDataFromDate-Msg")} />
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="basic-addon1">
                    <img src={iconcontentcalendar} alt="calendar" />
                  </span>
                </div>
                <Controller
                  as={DatePicker}
                  control={control}
                  autoComplete="off"
                  className="form-control"
                  dateFormat="dd.MM.yyyy"
                  name="subscriptionValidFrom"
                  showYearDropdown={true}
                  rules={{ required: true }}
                  locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                  valueName="selected"
                  value={dateHelper.formatUtcToDate(
                    values.subscriptionValidFrom
                  )}
                  onChange={function ([selected]) {
                    handleInputChange(
                      "subscriptionValidFrom",
                      dateHelper.datePickerDateToUtc(selected)
                    );
                    return selected;
                  }}
                  // maxDate={new Date(values.subscriptionValidTo)}
                />
              </div>
              {errors.subscriptionValidFrom &&
                errors.subscriptionValidFrom.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
            </div>
            {/* <div className="form-group">
              <label htmlFor="activationCode">
                {translator("Onboarding-POSData-SubcriptionToDate")}
              </label>{" "}
              <Tooltip text={translator("PosDataToDate-Msg")} />
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="basic-addon1">
                    <img src={iconcontentcalendar} alt="calendar" />
                  </span>
                </div>
                <Controller
                  as={DatePicker}
                  control={control}
                  autoComplete="off"
                  className="form-control"
                  dateFormat="dd.MM.yyyy"
                  name="subscriptionValidTo"
                  showYearDropdown={true}
                  rules={{ required: true }}
                  locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                  valueName="selected"
                  value={dateHelper.formatUtcToDate(values.subscriptionValidTo)}
                  onChange={function ([selected]) {
                    handleInputChange(
                      "subscriptionValidTo",
                      dateHelper.datePickerDateToUtc(selected)
                    );
                    return selected;
                  }}
                  minDate={new Date(values.subscriptionValidFrom)}
                />
              </div>
              {errors.subscriptionValidTo &&
                errors.subscriptionValidTo.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
            </div> */}
          </fieldset>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <button className="btn btn-outline-secondary" onClick={back}>
            {translator("Onboarding-Btn-Back")}
          </button>
        </div>
        <div className="col-6 text-right">
          <button className="btn btn-primary" onClick={handleSubmit(goTo)}>
            {translator("Onboarding-Btn-Next")}
          </button>
        </div>
      </div>
    </>
  );
};

export default PosData;
